import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { AbstractGuard } from '../shared';
import * as _firebase from 'firebase/app';
import { 
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from '../../services';
const firebase = _firebase;

@Injectable({
  providedIn: 'root'
})
export class ReplyGuard implements CanActivate {
  constructor (
    private auth:AuthService,
    private abstractGaurd:AbstractGuard,
  ) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const survey_id = next.params.survey_id || next.queryParams.survey_id;
    return this.abstractGaurd.canActivate(next, state).pipe(
      switchMap(bool=>{
        if (!bool || !this.checkAgainstScope()) {
          return this.auth.upgradeToken(survey_id).pipe(map(()=>this.checkAgainstScope()));
        } else {
          return of(bool);
        } 
      }),
    );
  }
  checkAgainstScope() {
    const idTokenResult = this.auth._idTokenResult;
    const scope: string = get(idTokenResult, 'claims.reply');
    const _as: string = get(idTokenResult, 'claims.as');
    return typeof _as === 'string' && _as.includes(scope);
  }
}
